import { appInfo } from '../config/appinfo'

const fetchWithCredentials = async (url: string, options: RequestInit = {}) => {
  const response = await fetch(url, {
    ...options,
    credentials: 'include',
    headers: {
      ...options.headers,
      'Content-Type': 'application/json',
    },
  })

  if (!response.ok) {
    throw new Error(`Failed to fetch: ${response.statusText}`)
  }
  return response.json()
}

export const authAPI = {
  getCurrentUser: () =>
    fetchWithCredentials(`${appInfo.apiDomain}/api/auth/me`),
}
